/* Shared storefront offer analytics. Events are published to Shopify's customer
 * events bus; a consent-aware direct send is used only in legacy contexts where
 * that bus is unavailable. Every event carries an id for API deduplication. */
(function () {
  if (window.CaffeineOfferAnalytics) return;

  var config = window.CaffeineOfferAnalyticsConfig || {};
  var endpoint = config.endpoint || 'https://admin.caffeinecommerce.com/api/events';
  var sessionKey = 'caffeine_offer_session';
  var sessionId;
  try {
    sessionId = sessionStorage.getItem(sessionKey);
    if (!sessionId) {
      sessionId = createId();
      sessionStorage.setItem(sessionKey, sessionId);
    }
  } catch (_error) {
    sessionId = createId();
  }

  function createId() {
    return window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function normalizeGid(kind, value) {
    if (value == null || value === '') return null;
    var stringValue = String(value);
    return stringValue.indexOf('gid://') === 0
      ? stringValue
      : 'gid://shopify/' + kind + '/' + stringValue;
  }

  function track(eventType, fields) {
    fields = fields || {};
    var payload = {
      eventId: fields.eventId || createId(),
      shop: config.shop || (window.Shopify && window.Shopify.shop) || '',
      placement: fields.placement || 'pdp',
      eventType: eventType,
      sessionId: sessionId,
      offerType: fields.offerType || null,
      offerId: fields.offerId || fields.offerType || null,
      offerRevision: fields.offerRevision == null ? null : Number(fields.offerRevision),
      offerInstanceId: fields.offerInstanceId || null,
      role: fields.role || null,
      productId: normalizeGid('Product', fields.productId),
      variantId: normalizeGid('ProductVariant', fields.variantId),
      sourceProductId: normalizeGid('Product', fields.sourceProductId),
      productTitle: fields.productTitle || null,
      amount: fields.amount == null ? null : Number(fields.amount),
      currency: fields.currency || config.currency || null,
      quantity: fields.quantity == null ? null : Number(fields.quantity),
      detail: fields.detail || null
    };

    var published = false;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('caffeine:offer_event', payload);
        published = true;
      }
    } catch (_publishError) {}

    // Legacy fallback for contexts where Shopify's event bus is unavailable.
    // When the Customer Privacy API is present, never bypass its analytics gate.
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var analyticsAllowed = !privacy || typeof privacy.analyticsProcessingAllowed !== 'function'
      ? true
      : privacy.analyticsProcessingAllowed();
    try {
      if (!published && analyticsAllowed) fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (_sendError) {}
    return payload;
  }

  function fieldsFromElement(element) {
    var host = element && element.closest ? element.closest('[data-caffeine-offer]') : null;
    if (!host) return null;
    return {
      placement: host.dataset.caffeinePlacement || 'pdp',
      offerType: host.dataset.caffeineOfferType,
      offerId: host.dataset.caffeineOfferId,
      offerRevision: host.dataset.caffeineOfferRevision,
      productId: host.dataset.caffeineProductId,
      sourceProductId: host.dataset.caffeineSourceProductId,
      productTitle: host.dataset.caffeineProductTitle
    };
  }

  function observe(root) {
    var nodes = (root || document).querySelectorAll('[data-caffeine-offer]');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        if (!node.dataset.caffeineImpression) {
          node.dataset.caffeineImpression = 'true';
          track('impression', fieldsFromElement(node));
        }
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.target.dataset.caffeineImpression) return;
        entry.target.dataset.caffeineImpression = 'true';
        track('impression', fieldsFromElement(entry.target));
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
    nodes.forEach(function (node) {
      if (!node.dataset.caffeineImpression) observer.observe(node);
    });
  }

  document.addEventListener('click', function (event) {
    var action = event.target.closest('[data-caffeine-action]');
    if (!action) return;
    var fields = fieldsFromElement(action);
    if (!fields) return;
    fields.detail = { action: action.dataset.caffeineAction };
    track('click', fields);
  });
  document.addEventListener('DOMContentLoaded', function () { observe(document); });
  if ('MutationObserver' in window) {
    var pendingObserve = false;
    new MutationObserver(function (mutations) {
      if (pendingObserve || !mutations.some(function (mutation) { return mutation.addedNodes.length; })) return;
      pendingObserve = true;
      requestAnimationFrame(function () {
        pendingObserve = false;
        observe(document);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.CaffeineOfferAnalytics = {
    track: track,
    observe: observe,
    fieldsFromElement: fieldsFromElement,
    sessionId: sessionId
  };
})();
